import Service from '../../services'
import { checkAndReturn } from "../../main"

const state = {

}

const getters = {

}

const actions = {
    async uploadFile ({ commit }, data) {
        return await Service.Attachment.uploadFile(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    }

}

const mutations = {

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
